import { put, takeLatest, fork, call } from 'redux-saga/effects';
import {
  REGISTER_INIT_REQUEST,
  REGISTER_VERIFY_REQUEST,
  REGISTER_CREATE_USER_REQUEST,
} from '../constants';
import {
  registerInitSuccess,
  registerInitFailure,
  registerVerifySuccess,
  registerVerifyFailure,
  registerCreateUserSuccess,
  registerCreateUserFailure,
} from '../actions';

import {
  apiRegisterInit,
  apiRegisterVerify,
  apiRegisterCreateUser,
} from '../../api';

function* sagaRegisterInitSaga(action) {
  try {
    const data = yield call(apiRegisterInit, action.payload);
    yield put(registerInitSuccess(data));
  } catch (e) {
    yield put(registerInitFailure(e));
  }
}

function* sagaRegisterVerify(action) {
  try {
    const data = yield call(apiRegisterVerify, action.payload);
    yield put(registerVerifySuccess(data));
  } catch (e) {
    yield put(registerVerifyFailure(e));
  }
}

function* sagaRegisterCreateUser(action) {
  try {
    const data = yield call(apiRegisterCreateUser, action.payload);
    yield put(registerCreateUserSuccess(data));
  } catch (e) {
    yield put(registerCreateUserFailure(e));
  }
}

function* getKeepaProcess() {
  yield takeLatest(REGISTER_INIT_REQUEST, sagaRegisterInitSaga);
  yield takeLatest(REGISTER_VERIFY_REQUEST, sagaRegisterVerify);
  yield takeLatest(REGISTER_CREATE_USER_REQUEST, sagaRegisterCreateUser);
}

export default [fork(getKeepaProcess)];
